import { render } from "./shiftCompletionModel.vue?vue&type=template&id=95a47394"
import script from "./shiftCompletionModel.vue?vue&type=script&lang=js"
export * from "./shiftCompletionModel.vue?vue&type=script&lang=js"

import "./shiftCompletionModel.vue?vue&type=style&index=0&id=95a47394&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__